import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-quickbooks-callback',
  templateUrl: './quickbooks-callback.component.html',
  styleUrls: ['./quickbooks-callback.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class QuickbooksCallbackComponent implements OnInit {
  code: string | null = null;
  realmId: string | null = null;
  error: string | null = null;
  status: 'processing' | 'success' | 'error' = 'processing';

  constructor(private route: ActivatedRoute, private titleService: Title) {}

  ngOnInit() {
    this.titleService.setTitle('QuickBooks Callback');
    this.route.queryParams.subscribe((params: { [key: string]: string }) => {
      this.code = params['code'] || null;
      this.realmId = params['realmId'] || null;
      this.error = params['error'] || null;

      if (this.error) {
        this.status = 'error';
      } else if (this.code && this.realmId) {
        this.status = 'success';
      } else {
        this.status = 'error';
      }
    });
  }
}
